import api from './api';

export interface StoreConfiguration {
    id: number;
    storeName: string;
    address: string | null;
    phone: string | null;
    email: string | null;
    taxRate: number;
    currencySymbol: string;
    defaultMinStockThreshold: number;
    receiptHeader: string | null;
    receiptFooter: string | null;
}

const settingsService = {
    getSettings: async (): Promise<StoreConfiguration> => {
        const response = await api.get('/settings');
        return response.data;
    },

    updateSettings: async (settings: StoreConfiguration): Promise<void> => {
        await api.put('/settings', settings);
    }
};

export default settingsService;
